import React from "react"
import { twMerge } from "tailwind-merge"

import { getPublicReviewCount } from "../../utils/publicReviewCount"

import ReviewStars from "./ReviewStars"

const PracticeReviewsProfile = ({ practice, className }) => {
  const reviewCount = getPublicReviewCount(practice)
  const profilePhotoUrl = practice.user?.profilePhotoUrl
  const userName =
    practice.user?.firstName && practice.user?.lastName
      ? `${practice.user.firstName} ${practice.user.lastName}`
      : practice.user?.name
  const theme = practice.theme

  return (
    <div className={twMerge("flex items-center gap-4", className)}>
      {/* Profile Photo */}
      <div className="size-16 shrink-0">
        {profilePhotoUrl ? (
          <img src={profilePhotoUrl} alt={userName} className="size-full rounded-xl object-cover" />
        ) : (
          <div className="flex size-full items-center justify-center rounded-full bg-gray-light">
            <span className="text-xl font-bold" style={{ color: theme.colorTextDark }}>
              {userName?.charAt(0)?.toUpperCase() || "?"}
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div>
        <h3 className="text-xl font-bold" style={{ color: theme.colorTextDark, fontFamily: theme.fontHeading }}>
          {userName}
        </h3>
        <div className="flex items-center gap-2">
          <ReviewStars rating={practice.averageRating} />
          <span className="text-sm" style={{ color: theme.colorTextDark }}>
            {reviewCount} reviews
          </span>
        </div>
      </div>
    </div>
  )
}

export default PracticeReviewsProfile
